import React, { useContext, useEffect, useState } from 'react'
import { ButtonBlue } from '../../Buttons/ButtonBlue'
import { CustomModal } from '../../CustomModal/CustomModal'
import { Spinner } from 'reactstrap';
import { t } from 'i18next';
import peopleToVisitSuccessIcon from '../../../assets/icons/people-to-visit-success-icon.svg';
import { useNavigate } from 'react-router-dom'
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import PeopleToVisitManagementContext from '../../../context/PeopleToVisitContext/PeopleToVisitManagementContext';

export const AmountOfPeopleToVisit = () => {
    const navigate = useNavigate();

    const { peopleToVisitManagementState, getAmountOfPeopleToVisit, setAmountOfPeopleToVisit, cleanPeopleToVisitState } = useContext(PeopleToVisitManagementContext);
    const { amountOfPeopleAllowed, responsePeopleToVisitService, isFetching } = peopleToVisitManagementState;

    const [amountState, setAmountState] = useState(amountOfPeopleAllowed);

    const disabled = !!!String(amountState).trim();

    const handleChange = (e) => {
        let { value } = e.target;
        setAmountState(Number(value))
    }

    const handleSubmit = async () => {
        if (disabled) return
        const amountSetting = {
            keyword: 'maximum_people_to_visit',
            setting_value: amountState
        }

        await setAmountOfPeopleToVisit(amountSetting);
    }

    const closeWarningModal = async () => {
        await cleanPeopleToVisitState();
        navigate('/settings/params/preferences');
    }

    useEffect(() => {
        getAmountOfPeopleToVisit();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setAmountState(amountOfPeopleAllowed);
        // eslint-disable-next-line
    }, [amountOfPeopleAllowed])


    return (
        <div className='row justify-content-center w-100'>
            <div className=''>
                <div className='me-3 ms-3 mt-2'>

                    <CustomModal showModal={responsePeopleToVisitService.show} centered={true} setShowModal={closeWarningModal}>
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={responsePeopleToVisitService.type === 'ERROR' ? errorIcon : peopleToVisitSuccessIcon} alt="" />
                            <p className='mt-3 text-center param-section-title'>{responsePeopleToVisitService.text}</p>
                            <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
                        </div>
                    </CustomModal>

                    {isFetching ?
                        <div className="d-flex mt-4 justify-content-center">
                            <Spinner />
                        </div>
                        : null}

                    <div>
                        <p className='m-0 titlelabel-filter'>{t('AMOUNT_PEOPLE_ALLOWED')}</p>
                        <p>
                            <input
                                className='form-control'
                                type="number"
                                name='setting_value'
                                value={amountState.toString()}
                                onChange={handleChange}
                            />
                        </p>
                    </div>

                    <div className='mt-3'>
                        <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
                            <div className=''>
                                <p type='button' className='m-0' onClick={() => navigate(-1)}>{t('CANCEL')}</p>
                            </div>

                            <div className=''>
                                <ButtonBlue onClick={handleSubmit} disabled={disabled}>
                                    {t('SAVE')}
                                </ButtonBlue>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
